// Every UI string, English and Arabic side by side. `npm run lint` fails if a key used in the code
// is missing here. Keep sentences short, plain and action-led; Arabic is Modern Standard Arabic.
export const M = {
  // App frame
  "nav.browse": ["Browse", "تصفّح"],
  "nav.sell": ["Sell", "بيع"],
  "nav.account": ["Account", "حسابي"],
  "nav.back": ["Back", "رجوع"],
  "lang.switch": ["العربية", "English"],
  "lang.label": ["Language", "اللغة"],

  // Information pages and footer
  "info.help": ["Help", "المساعدة"],
  "info.about": ["About Walashy", "عن Walashy"],
  "info.terms": ["Terms and conditions", "الشروط والأحكام"],
  "info.privacy": ["Privacy policy", "سياسة الخصوصية"],
  "info.safety": ["Buying and selling safely", "الشراء والبيع بأمان"],
  "info.contact": ["Contact us", "تواصل معنا"],
  "info.more": ["Help and information", "المساعدة والمعلومات"],
  "info.updated": ["Last updated {d}", "آخر تحديث {d}"],
  "info.helpIntro": ["Answers to the questions we hear most. Can't find yours? Contact us.", "إجابات أكثر الأسئلة شيوعاً. لم تجد سؤالك؟ تواصل معنا."],
  "info.stillNeedHelp": ["Still need help?", "ما زلت تحتاج مساعدة؟"],
  "info.contactIntro": ["We're here to help with deals, listings, safety and your account.", "نحن هنا لمساعدتك في الصفقات والإعلانات والأمان وحسابك."],
  "info.email": ["E-mail", "البريد الإلكتروني"],
  "info.whatsapp": ["WhatsApp", "واتساب"],
  "info.privacyEmail": ["Privacy requests", "طلبات الخصوصية"],
  "info.hours": ["We reply within one working day, Sunday to Thursday.", "نرد خلال يوم عمل واحد، من الأحد إلى الخميس."],
  "info.dealTip": ["About a deal? Report it from the deal itself (Inbox → the deal → Report it to us) so both sides and the record are attached.", "بخصوص صفقة؟ أبلغ عنها من الصفقة نفسها (الرسائل ← الصفقة ← أبلغنا) ليُرفق الطرفان والسجل."],
  "info.cr": ["CR", "السجل التجاري"],
  "signin.agree": ["By continuing you agree to our", "بالمتابعة فإنك توافق على"],

  // Help requests and deal problems
  "support.reportClosed": ["This deal ended more than a week ago, so it can't have a problem reported here. Contact us instead.", "انتهت هذه الصفقة منذ أكثر من أسبوع، فلا يمكن الإبلاغ عن مشكلة فيها هنا. تواصل معنا بدلاً من ذلك."],
  "support.reason.no_show": ["They didn't turn up", "لم يحضر في الموعد"],
  "support.reason.safety": ["Staying safe", "الأمان"],
  "support.onYourDeal": ["About a deal you're in", "بخصوص صفقة أنت طرف فيها"],
  "support.deal": ["Deal", "الصفقة"],
  "support.otherHint": ["{name} reported a problem with your deal. Reply here so our team hears your side; they read it too.", "أبلغ {name} عن مشكلة في صفقتكما. رد هنا ليسمع فريقنا وجهة نظرك؛ فهو يقرأ المحادثة أيضاً."],
  "deal.reportProblem": ["Something wrong with this deal? Report it to us", "هل هناك مشكلة في هذه الصفقة؟ أبلغنا"],
  "deal.openIssue": ["Help request #{n} is open: see the replies", "طلب المساعدة رقم {n} مفتوح: اطّلع على الردود"],
  "support.title": ["Help requests", "طلبات المساعدة"],
  "support.request": ["Help request", "طلب المساعدة"],
  "support.reportTitle": ["Report a problem", "الإبلاغ عن مشكلة"],
  "support.reportHint": ["Tell us what went wrong. The other person and our team see it. Walashy holds no money, so we can't refund; we can warn, suspend accounts and take listings down.", "أخبرنا بما حدث. يراه الطرف الآخر وفريقنا. لا يحتفظ Walashy بأي أموال فلا يمكننا رد المبلغ، لكن يمكننا التحذير وإيقاف الحسابات وإزالة الإعلانات."],
  "support.whatsWrong": ["What's wrong?", "ما المشكلة؟"],
  "support.details": ["Tell us what happened", "أخبرنا بما حدث"],
  "support.detailsHint": ["You can add photos on the next screen.", "يمكنك إضافة صور في الشاشة التالية."],
  "support.send": ["Send", "إرسال"],
  "support.sent": ["Sent. The other person and our team can see it. Add photos of the problem below.", "تم الإرسال. يراه الطرف الآخر وفريقنا. أضف صوراً للمشكلة أدناه."],
  "support.reason.not_received": ["Paid, but it never came", "دفعت ولم يصلني"],
  "support.reason.not_as_described": ["Not as described", "غير مطابق للوصف"],
  "support.reason.locked": ["Locked to someone's account", "مقفل بحساب شخص آخر"],
  "support.reason.not_genuine": ["Not genuine", "غير أصلي"],
  "support.reason.damaged": ["It's damaged", "الجهاز تالف"],
  "support.reason.account": ["My account", "حسابي"],
  "support.reason.selling": ["Selling", "البيع"],
  "support.reason.other": ["Something else", "شيء آخر"],
  "support.status.open": ["Open", "مفتوح"],
  "support.status.resolved": ["Resolved", "تم الحل"],
  "support.status.closed": ["Closed", "مغلق"],
  "support.empty": ["No help requests", "لا توجد طلبات مساعدة"],
  "support.emptyBody": ["Problems you report and questions you send appear here.", "تظهر هنا المشكلات التي تبلغ عنها والأسئلة التي ترسلها."],
  "support.team": ["Walashy team", "فريق Walashy"],
  "support.you": ["You", "أنت"],
  "support.conversation": ["Conversation", "المحادثة"],
  "support.photos": ["Photos", "الصور"],
  "support.photo": ["Photo of the problem", "صورة المشكلة"],
  "support.reply": ["Your reply", "ردك"],
  "support.sendReply": ["Send reply", "إرسال الرد"],
  "support.addPhoto": ["Add photo", "إضافة صورة"],
  "support.closeIt": ["My problem is solved: close this request", "حُلت مشكلتي: أغلق الطلب"],
  "support.closedHint": ["This request is closed. Need more help?", "هذا الطلب مغلق. تحتاج مساعدة إضافية؟"],
  "support.askTitle": ["Send us a message", "أرسل لنا رسالة"],
  "support.signInToAsk": ["Sign in so we can reply to you and see your deals.", "سجّل الدخول لنتمكن من الرد عليك والاطلاع على صفقاتك."],
  "support.topic": ["Topic", "الموضوع"],
  "support.subject": ["Subject", "العنوان"],
  "support.message": ["Message", "الرسالة"],
  "support.whatsapp": ["Chat with us on WhatsApp", "تحدّث معنا عبر واتساب"],
  "account.support": ["Help requests", "طلبات المساعدة"],

  // Your data (PDPL)
  "data.title": ["Your data", "بياناتك"],
  "data.body": ["Download a copy of everything we hold about you, or delete your account.", "نزّل نسخة من كل ما لدينا عنك، أو احذف حسابك."],
  "data.download": ["Download my data", "تنزيل بياناتي"],
  "data.delete": ["Delete my account", "حذف حسابي"],
  "data.deleteWarn": ["This can't be undone. Your listings come down, deals still being talked about are cancelled, and your contact details are erased. Completed deals, bills of sale and reviews stay as records, without your name.", "لا يمكن التراجع عن ذلك. تُزال إعلاناتك وتُلغى الصفقات التي ما زالت قيد النقاش وتُمحى بيانات التواصل. وتبقى الصفقات المكتملة وعقود البيع والتقييمات كسجلات دون اسمك."],
  "data.deleteBlocked": ["First finish or cancel {n} reserved deal(s): someone is counting on them.", "أكمل أو ألغِ أولاً {n} صفقة محجوزة؛ هناك من ينتظرها."],
  "data.deleteOpenDeals": ["{n} deal(s) you're talking about will be cancelled, and the other person told.", "ستُلغى {n} صفقة قيد النقاش ويُبلَّغ الطرف الآخر."],
  "data.typeDelete": ["Type DELETE to confirm", "اكتب DELETE للتأكيد"],
  "data.deleteConfirm": ["Delete my account for good", "احذف حسابي نهائياً"],

  // Warranty
  "warranty.title": ["Warranty", "الضمان"],
  "warranty.none": ["No warranty", "بدون ضمان"],
  "warranty.manufacturer": ["Maker's warranty still running", "ضمان الشركة المصنّعة ما زال سارياً"],
  "warranty.manufacturerHint": ["Until when? Check it in Settings → General → About (iPhone) or the maker's site.", "حتى متى؟ تحقّق منه في الإعدادات ← عام ← حول (آيفون) أو موقع الشركة."],
  "warranty.until": ["Valid until", "ساري حتى"],
  "warranty.seller": ["My own warranty (shops)", "ضمان من المتجر"],
  "warranty.months": ["Months", "عدد الأشهر"],
  "warranty.badge": ["Warranty", "ضمان"],
  "warranty.manufacturerUntil": ["Maker's warranty until {d}", "ضمان الشركة حتى {d}"],
  "warranty.sellerMonths": ["Seller warranty: {n} months", "ضمان البائع: {n} أشهر"],
  "filters.warranty": ["With warranty only", "بضمان فقط"],
  "filters.color": ["Colour", "اللون"],

  // Payment methods

  // Shipment tracking

  // Trust: IMEI and registered shops
  "imei.label": ["IMEI", "رقم IMEI"],
  "imei.hint": ["Dial *#06# to see it. Kept private: buyers only see that one is recorded. Read it out at the handover so the buyer can check it against the phone.", "اطلب ‎*#06#‎ لعرضه. يبقى سرياً: يرى المشترون فقط أنه مسجّل. اقرأه عند التسليم ليطابقه المشتري مع الجوال."],
  "imei.saved": ["Recorded: ends in {d}", "مسجّل: ينتهي بـ {d}"],
  "imei.change": ["Change", "تغيير"],
  "imei.recorded": ["IMEI recorded with Walashy", "رقم IMEI مسجّل لدى Walashy"],
  "shop.registered": ["Registered business", "منشأة مسجّلة"],
  "shop.cr": ["CR", "السجل التجاري"],
  "shop.vat": ["VAT no.", "الرقم الضريبي"],
  "verify.title": ["Get verified", "احصل على التوثيق"],
  "verify.body": ["Verified sellers get a badge and more buyer trust. Shops: add your commercial registration so buyers see a registered business.", "يحصل البائع الموثّق على شارة وثقة أكبر من المشترين. للمتاجر: أضف سجلك التجاري ليرى المشترون أنك منشأة مسجّلة."],
  "verify.isShop": ["I'm a registered shop", "أنا متجر مسجّل"],
  "verify.businessName": ["Business name", "اسم المنشأة"],
  "verify.cr": ["Commercial registration number", "رقم السجل التجاري"],
  "verify.crHint": ["10 digits, as on your CR certificate.", "١٠ أرقام كما في شهادة السجل التجاري."],
  "verify.vat": ["VAT registration number", "رقم التسجيل الضريبي"],
  "verify.vatHint": ["15 digits, starts and ends with 3. Leave empty if you aren't VAT-registered.", "١٥ رقماً يبدأ وينتهي بـ ٣. اتركه فارغاً إن لم تكن مسجّلاً في الضريبة."],
  "verify.send": ["Request verification", "اطلب التوثيق"],
  "info.vat": ["VAT no.", "الرقم الضريبي"],

  // Shared states
  "state.loading": ["Loading…", "جارٍ التحميل…"],
  "state.error": ["Something went wrong", "حدث خطأ"],
  "state.retry": ["Try again", "حاول مرة أخرى"],
  "state.offline": ["You're offline. Check your connection and try again.", "أنت غير متصل. تحقق من الاتصال وحاول مجدداً."],
  "common.save": ["Save", "حفظ"],
  "common.cancel": ["Cancel", "إلغاء"],
  "common.continue": ["Continue", "متابعة"],
  "common.done": ["Done", "تم"],
  "common.edit": ["Edit", "تعديل"],
  "common.remove": ["Remove", "إزالة"],
  "common.optional": ["Optional", "اختياري"],
  "common.each": ["each", "للقطعة"],
  "common.qty": ["Quantity", "الكمية"],
  "common.available": ["{n} available", "{n} متاحة"],
  "common.seeAll": ["See all", "عرض الكل"],
  "common.close": ["Close", "إغلاق"],
  "common.yes": ["Yes", "نعم"],
  "common.no": ["No", "لا"],
  "common.signInToContinue": ["Sign in to continue", "سجّل الدخول للمتابعة"],
  "common.reported": ["Thanks. Our team will review it.", "شكراً. سيراجعه فريقنا."],
  "common.saved": ["Saved", "تم الحفظ"],

  // Categories & conditions
  "cat.phone": ["Phone", "جوال"],
  "cat.laptop": ["Laptop", "لابتوب"],
  "cat.phones": ["Phones", "جوالات"],
  "cat.laptops": ["Laptops", "لابتوبات"],
  "cond.new": ["New, sealed", "جديد بالكرتونة"],
  "cond.like_new": ["Like new", "كالجديد"],
  "cond.good": ["Good", "جيد"],
  "cond.fair": ["Fair", "مقبول"],
  "cond.for_parts": ["For parts", "قطع غيار"],
  "cond.new.hint": ["Unopened, in the original box", "لم يُفتح، في علبته الأصلية"],
  "cond.like_new.hint": ["No visible marks", "بلا آثار استخدام ظاهرة"],
  "cond.good.hint": ["Light marks, works perfectly", "آثار خفيفة، يعمل بشكل ممتاز"],
  "cond.fair.hint": ["Visible wear, works", "آثار استخدام واضحة، يعمل"],
  "cond.for_parts.hint": ["Faulty or not working", "به عطل أو لا يعمل"],
  "cond.atLeast": ["{c} or better", "{c} أو أفضل"],

  // Specs
  "spec.brand": ["Brand", "العلامة التجارية"],
  "spec.model": ["Model", "الطراز"],
  "spec.model_number": ["Model number", "رقم الطراز"],
  "spec.storage": ["Storage", "سعة التخزين"],
  "spec.ram": ["Memory (RAM)", "الذاكرة (RAM)"],
  "spec.os_version": ["Software version", "إصدار النظام"],
  "spec.battery_health": ["Battery health", "صحة البطارية"],
  "spec.color": ["Colour", "اللون"],
  "spec.processor": ["Processor", "المعالج"],
  "spec.graphics": ["Graphics", "بطاقة الرسومات"],
  "spec.screen_size": ["Screen size", "حجم الشاشة"],
  "spec.year": ["Year", "سنة الإصدار"],
  "spec.aboutThisDevice": ["About this device", "حول هذا الجهاز"],
  "spec.fromAbout": ["Read from the seller's About screen", "مقروء من شاشة «حول» لدى البائع"],
  "spec.fromAboutShort": ["From About screen", "من شاشة «حول»"],
  "spec.confirm": ["Confirm", "تأكيد"],
  "spec.confirmed": ["Confirmed", "مؤكد"],
  "spec.check": ["Please check", "يرجى التحقق"],

  // Trade grades (condition shown the way the refurbished-device market reads it)
  "grade.new": ["NEW", "جديد"],
  "grade.like_new": ["A", "أ"],
  "grade.good": ["B", "ب"],
  "grade.fair": ["C", "ج"],
  "grade.for_parts": ["D", "د"],
  "grade.label": ["Grade {g}", "الفئة {g}"],

  // Home hero and trust strip
  "trust.grade.t": ["Graded condition", "حالة مُصنّفة"],
  "trust.grade.b": ["From A to D, with every defect listed and photographed.", "من أ إلى د، مع ذكر كل عيب وتصويره."],
  "trust.private.t": ["Contact your way", "تواصل بطريقتك"],
  "trust.private.b": ["Chat in Walashy, or WhatsApp the seller if they allow it.", "تحدّث داخل Walashy، أو راسل البائع على واتساب إن سمح بذلك."],
  "home.title": ["Phones from people, no fees in between", "جوالات من الناس، بدون رسوم بينكم"],
  "home.lede": ["Every phone graded A to D, priced against the market. Talk to the seller directly and pay them yourself. Walashy is free.", "كل جوال مصنّف من أ إلى د، وسعره مقارن بالسوق. تواصل مع البائع مباشرة وادفع له بنفسك. Walashy مجاني."],
  "home.sellCta": ["Sell your phone", "بِع جوالك"],
  "home.brands": ["Shop by brand", "تسوّق حسب الماركة"],
  "home.deals": ["Biggest savings", "أكبر توفير"],
  "home.dealsHint": ["Compared with the price new", "مقارنةً بسعره جديداً"],
  "home.seeAll": ["See all", "عرض الكل"],
  "home.live": ["{n} phones for sale now", "{n} جوال معروض الآن"],
  "catalog.all": ["All phones", "كل الجوالات"],
  "filters.brand": ["Brand", "الماركة"],
  "filters.model": ["Model", "الطراز"],
  "filters.version": ["Version", "الإصدار"],
  "browse.allModels": ["All models", "كل الطرازات"],
  "browse.allOf": ["All {s}", "كل {s}"],
  "filters.storage": ["Storage", "السعة"],
  "filters.condition": ["Condition", "الحالة"],
  "filters.price": ["Price", "السعر"],
  "filters.min": ["Min", "من"],
  "filters.max": ["Max", "إلى"],
  "filters.under": ["Under {p}", "أقل من {p}"],
  "filters.over": ["Over {p}", "أكثر من {p}"],
  "filters.range": ["{a} – {b}", "{a} – {b}"],
  "filters.delivery": ["How you get it", "طريقة الاستلام"],
  "filters.any": ["Any", "الكل"],
  "filters.anyCondition": ["Any condition", "أي حالة"],
  "filters.clear": ["Clear all", "مسح الكل"],
  "filters.show": ["Show results ({n})", "عرض النتائج ({n})"],
  "filters.open": ["Filters", "التصفية"],
  "filters.active": ["Filters ({n})", "التصفية ({n})"],
  "sort.label": ["Sort by", "الترتيب"],
  "browse.sort.savings": ["Biggest savings", "الأكثر توفيراً"],
  "browse.laptopsSoon": ["Laptops are coming soon. For now Walashy is all about phones.", "اللابتوبات قريباً. حالياً نركّز على الجوالات فقط."],
  "card.save": ["Save {p}%", "وفّر {p}٪"],
  "card.new": ["New", "جديد"],
  "listing.savings": ["{p}% below the price new", "أقل من سعره جديداً بـ {p}٪"],
  "listing.newPrice": ["Price new", "سعره جديداً"],
  "listing.compare": ["Same phone from other sellers", "نفس الجوال من بائعين آخرين"],
  "listing.compareHint": ["Compare price and condition before you buy.", "قارن السعر والحالة قبل أن تشتري."],
  "listing.photo": ["Photo {n}: {v}", "الصورة {n}: {v}"],
  "listing.details": ["Details", "التفاصيل"],
  "card.saveVsNew": ["Save {p}% vs new", "وفّر {p}٪ عن الجديد"],
  "grades.what": ["What do the grades mean?", "ما الفرق بين الحالات؟"],
  "grades.title": ["Condition grades", "فئات الحالة"],
  "grades.intro": ["Every phone is checked and given one of these grades. Defects are listed and photographed on the listing.", "كل جوال يُفحص ويُعطى إحدى هذه الفئات، وتُذكر العيوب وتُصوَّر في الإعلان."],
  "trust.checked": ["Every phone graded", "كل جوال مصنّف"],
  "trust.private": ["Your number stays private", "رقمك يبقى خاصاً"],
  "catalog.heading": ["Phones for sale", "جوالات للبيع"],
  "catalog.heading.laptop": ["Laptops for sale", "لابتوبات للبيع"],
  "catalog.count": ["{n} phones", "{n} جوال"],
  "catalog.count.laptop": ["{n} laptops", "{n} لابتوب"],
  "catalog.for": ["Results for “{q}”", "نتائج «{q}»"],
  "catalog.showing": ["Showing {n} of {total}", "يُعرض {n} من {total}"],
  "catalog.more": ["Show more", "عرض المزيد"],
  "row.prev": ["Previous", "السابق"],
  "row.next": ["Next", "التالي"],
  "listing.condFrom": ["From {p}", "من {p}"],
  "listing.condNone": ["Not available", "غير متوفر"],
  "listing.ratingLine": ["{avg} out of 5, {n} reviews", "{avg} من 5، {n} تقييمات"],
  "listing.battery": ["Battery {b}", "البطارية {b}"],
  "a11y.skip": ["Skip to content", "انتقل إلى المحتوى"],
  "browse.latest": ["Latest listings", "أحدث الإعلانات"],

  // Browse & search
  "browse.title": ["Used phones, graded and priced clearly", "جوالات مستعملة مصنّفة وبأسعار واضحة"],
  "browse.searchLabel": ["What are you looking for?", "عمّ تبحث؟"],

  // Seller pages
  "seller.allListings": ["All this seller's listings", "كل إعلانات البائع"],
  "seller.verified": ["Verified seller", "بائع موثّق"],
  "seller.listings": ["On sale ({n})", "معروض للبيع ({n})"],
  "seller.noListings": ["Nothing on sale right now", "لا يوجد شيء معروض حالياً"],
  "seller.noListingsBody": ["Check back later, or browse phones from other sellers.", "عُد لاحقاً، أو تصفّح جوالات بائعين آخرين."],
  "seller.reviews": ["What people said", "ماذا قال من تعاملوا معه"],
  "seller.noReviews": ["No reviews yet.", "لا توجد تقييمات بعد."],
  "seller.stars": ["{n} out of 5", "{n} من 5"],

  // Home page slideshow
  "banners.label": ["Offers and news", "العروض والجديد"],
  "banners.slide": ["Slide {n} of {total}", "الشريحة {n} من {total}"],
  "banners.prev": ["Previous slide", "الشريحة السابقة"],
  "banners.next": ["Next slide", "الشريحة التالية"],

  // Landing page (/welcome)
  "welcome.title": ["Looking for a phone?", "تدوّر جوال؟"],
  "welcome.lede": ["Type what you have in mind, in your own words. Phones from people and shops across Saudi Arabia, each graded and priced against the market. No fees: talk to the seller and pay them directly.", "اكتب اللي في بالك بكلامك. جوالات من الناس والمحلات في كل المملكة، كل جوال بحالة واضحة وسعر مقارن بالسوق. بدون رسوم: تكلم البائع وادفع له مباشرة."],
  "welcome.hint": ["Try budgets, quantities or delivery: we understand them.", "جرّب الميزانية أو العدد أو التوصيل، نفهمها كلها."],
  "welcome.sample1": ["2 iPhone 13 under 1700 with delivery", "٢ ايفون ١٣ أقل من ١٧٠٠ توصيل"],
  "welcome.sample2": ["Galaxy S24 like new in Riyadh", "جالكسي S24 كالجديد في الرياض"],
  "welcome.sample3": ["iPhone 15 Pro 256 GB", "ايفون ١٥ برو ٢٥٦ جيجا"],
  "welcome.browse": ["Browse phones", "تصفّح الجوالات"],
  "welcome.videoLabel": ["Walashy in 25 seconds", "Walashy في ٢٥ ثانية"],
  "welcome.play": ["Play", "تشغيل"],
  "welcome.pause": ["Pause", "إيقاف"],
  "welcome.soundOn": ["Sound on", "تشغيل الصوت"],
  "welcome.soundOff": ["Sound off", "كتم الصوت"],
  "welcome.sell": ["Sell your phone", "بِع جوالك"],
  "welcome.promisesLabel": ["Why Walashy", "ليش Walashy"],
  "welcome.p.price.title": ["You know if the price is fair", "تعرف إذا السعر مناسب"],
  "welcome.p.price.body": ["Every phone is compared with what the same model actually sells for, so a great price stands out and a high one doesn't hide.", "كل جوال مقارن بسعر بيع نفس الطراز فعلياً، فيبان السعر الممتاز ولا يختفي السعر المبالغ فيه."],
  "welcome.p.grade.title": ["The condition is clear", "حالة كل جوال واضحة"],
  "welcome.p.grade.body": ["One grade for every phone, the same meaning everywhere: from new in the box to fair.", "تقييم واحد لكل جوال وبنفس المعنى في كل مكان: من جديد بالكرتونة إلى مقبول."],
  "welcome.p.privacy.title": ["Talk to the seller directly", "كلّم البائع مباشرة"],
  "welcome.p.privacy.body": ["Chat in Walashy or, if the seller allows it, open WhatsApp in one tap. Your own number stays yours until you choose to share it.", "تحدّث داخل Walashy، أو افتح واتساب بلمسة إن سمح البائع. ورقمك يبقى لك حتى تقرر مشاركته."],
  "welcome.p.privacy.message": ["Is it available? Can I see it today?", "متوفر؟ أقدر أشوفه اليوم؟"],
  "welcome.p.privacy.note": ["Every conversation is kept as a deal you can follow.", "كل محادثة تُحفظ كصفقة تتابعها."],
  "welcome.p.pay.title": ["Free, and every deal on record", "مجاني، وكل صفقة موثّقة"],
  "welcome.p.pay.body": ["No fees, no commission, no money held. Walashy keeps the record instead: the agreed price, the meetup, the buyer's checks and a bill of sale both of you confirm.", "بلا رسوم ولا عمولة ولا أموال محجوزة. Walashy يحفظ السجل بدلاً من ذلك: السعر المتفق عليه، واللقاء، وفحص المشتري، وعقد بيع يؤكده الطرفان."],
  "welcome.p.pay.s1": ["Agree a price", "اتفقا على السعر"],
  "welcome.p.pay.s2": ["Meet and check it", "تقابلا وافحص الجوال"],
  "welcome.p.pay.s3": ["Pay the seller directly", "ادفع للبائع مباشرة"],
  "welcome.sellTitle": ["Selling takes a minute", "البيع يأخذ دقيقة"],
  "welcome.step1.title": ["Say what it is", "اذكر ما هو"],
  "welcome.step1.body": ["Type the model, or screenshot the About screen and we read it.", "اكتب الطراز، أو صوّر شاشة «حول الجهاز» ونقرأها نحن."],
  "welcome.step2.title": ["Price it with the market", "سعّره حسب السوق"],
  "welcome.step2.body": ["See what this exact phone sells for, then add two photos.", "شوف بكم يُباع هذا الجوال بالضبط، ثم أضف صورتين."],
  "welcome.step3.title": ["Sell, keep everything", "بِع واحتفظ بالمبلغ كاملاً"],
  "welcome.step3.body": ["Buyers chat or WhatsApp you. They pay you directly; Walashy takes nothing.", "يراسلك المشترون أو يكلمونك على واتساب. يدفعون لك مباشرة؛ وWalashy لا يأخذ شيئاً."],
  "welcome.sellCta": ["List a phone", "اعرض جوالك"],
  "welcome.closing": ["Your next find is here", "لقطتك الجاية هنا"],
  "welcome.learnMore": ["What is Walashy?", "وش هو Walashy؟"],
  "browse.searchPlaceholder": ["Search phones or brands", "ابحث عن جوال أو ماركة"],
  "browse.search": ["Search", "بحث"],
  "browse.filters": ["Filters", "التصفية"],
  "browse.all": ["All", "الكل"],
  "filters.category": ["Category", "الفئة"],
  "browse.budget": ["Budget", "الميزانية"],
  "browse.upTo": ["Up to {p}", "حتى {p}"],
  "browse.from": ["From {p}", "من {p}"],
  "browse.qty": ["{n} units", "{n} قطع"],
  "browse.delivery": ["Delivery", "توصيل"],
  "browse.pickup": ["Pickup", "استلام"],
  "browse.sort.best": ["Best match", "الأنسب"],
  "browse.sort.price": ["Lowest price", "الأقل سعراً"],
  "browse.sort.newest": ["Newest", "الأحدث"],
  "browse.results": ["{n} results", "{n} نتيجة"],
  "browse.result1": ["1 result", "نتيجة واحدة"],
  "browse.empty.title": ["No matches yet", "لا توجد نتائج بعد"],
  "browse.empty.body": ["Try a higher budget or fewer filters, or turn on an alert and we'll tell you when one is listed.", "جرّب ميزانية أعلى أو تصفية أقل، أو فعّل تنبيهاً وسنخبرك عند عرضه."],
  "browse.totalFor": ["{total} for {n}", "{total} مقابل {n}"],
  "browse.inclDelivery": ["incl. delivery", "شامل التوصيل"],
  "browse.verified": ["Verified seller", "بائع موثّق"],
  "browse.removeFilter": ["Remove filter: {f}", "إزالة التصفية: {f}"],

  // Listing page
  "listing.condition": ["Condition", "الحالة"],
  "listing.defects": ["Defects", "العيوب"],
  "listing.noDefects": ["None reported", "لا يوجد عيوب مذكورة"],
  "listing.accessories": ["Included", "المرفقات"],
  "listing.description": ["From the seller", "من البائع"],
  "listing.freeDelivery": ["free", "مجاني"],
  "listing.memberSince": ["Member since {d}", "عضو منذ {d}"],
  "listing.reviews": ["{avg} ★ · {n} reviews", "{avg} ★ · {n} تقييم"],
  "listing.noReviews": ["No reviews yet", "لا توجد تقييمات بعد"],
  "listing.message": ["Message seller", "راسل البائع"],
  "listing.save": ["Save", "حفظ"],
  "listing.saved": ["Saved", "محفوظ"],
  "listing.report": ["Report listing", "الإبلاغ عن الإعلان"],
  "listing.soldOut": ["Sold out", "نفدت الكمية"],
  "listing.yours": ["This is your listing", "هذا إعلانك"],
  "listing.manage": ["Manage and see insights", "الإدارة والإحصاءات"],
  "listing.aiAssisted": ["Specs read from the device's About screen and confirmed by the seller", "المواصفات مقروءة من شاشة «حول» للجهاز وأكّدها البائع"],

  // Report
  "report.title": ["What's wrong?", "ما المشكلة؟"],
  "report.scam": ["Looks like a scam", "يبدو احتيالاً"],
  "report.stolen": ["Possibly stolen", "قد يكون مسروقاً"],
  "report.counterfeit": ["Counterfeit or fake", "مقلّد أو مزيّف"],
  "report.wrong_info": ["Wrong information", "معلومات خاطئة"],
  "report.abuse": ["Abusive", "مسيء"],
  "report.spam": ["Spam", "رسائل مزعجة"],
  "report.other": ["Something else", "سبب آخر"],
  "report.details": ["Details", "التفاصيل"],
  "report.send": ["Send report", "إرسال البلاغ"],

  // Sign in
  "signin.title": ["Sign in with your mobile number", "سجّل الدخول برقم جوالك"],
  "signin.why": ["We text you a code. Your number is never shown on listings.", "سنرسل إليك رمزاً. لن يظهر رقمك في الإعلانات."],
  "signin.emailTitle": ["Sign in or create an account", "سجّل الدخول أو أنشئ حساباً"],
  "signin.emailWhy": ["We e-mail you a code. New here? The same code creates your account. Your e-mail is never shown to other people.", "سنرسل رمزاً إلى بريدك. جديد هنا؟ الرمز نفسه ينشئ حسابك. لن يظهر بريدك لأي شخص."],
  "signin.email": ["E-mail", "البريد الإلكتروني"],
  "signin.emailHint": ["e.g. name@example.com", "مثلاً ⁦name@example.com⁩"],
  "signin.suggestions": ["E-mail suggestions", "اقتراحات البريد الإلكتروني"],
  "signin.didYouMean": ["Did you mean", "هل تقصد"],
  "signin.changeEmail": ["Change e-mail", "تغيير البريد"],
  "signin.checkSpam": ["Can't find it? Check your spam or junk folder.", "لم تجده؟ تحقق من مجلد الرسائل غير المرغوب فيها."],
  "signin.usePhone": ["Use a mobile number instead", "استخدم رقم الجوال بدلاً من ذلك"],
  "signin.useEmail": ["Use e-mail instead", "استخدم البريد الإلكتروني بدلاً من ذلك"],
  "signin.phone": ["Mobile number", "رقم الجوال"],
  "signin.phoneHint": ["Saudi mobile, e.g. 05X XXX XXXX or +966 5X XXX XXXX", "رقم جوال سعودي، مثلاً \u206605X XXX XXXX\u2069 أو \u2066+966 5X XXX XXXX\u2069"],
  "signin.sendCode": ["Send code", "أرسل الرمز"],
  "signin.code": ["Enter the 6-digit code", "أدخل الرمز المكوّن من 6 أرقام"],
  "signin.sentTo": ["Sent to {p}", "أُرسل إلى {p}"],
  "signin.verify": ["Sign in", "تسجيل الدخول"],
  "signin.resend": ["Send a new code", "أرسل رمزاً جديداً"],
  "signin.changeNumber": ["Change number", "تغيير الرقم"],
  "signin.devCode": ["Development mode. Your code is {c}", "وضع التطوير. رمزك هو {c}"],

  // Sell — hub
  "sell.title": ["Selling", "البيع"],
  "sell.new": ["New listing", "إعلان جديد"],
  "sell.empty.title": ["Sell your phone", "بِع جوالك"],
  "sell.empty.body": ["It takes about a minute: what it is, its condition and price, and two photos. Free, no commission.", "يستغرق نحو دقيقة: ما هو، وحالته وسعره، وصورتان. مجاناً وبلا عمولة."],
  "sell.status.draft": ["Draft", "مسودة"],
  "sell.status.active": ["Live", "منشور"],
  "sell.status.paused": ["Paused", "متوقف"],
  "sell.status.sold_out": ["Sold out", "نفدت الكمية"],
  "sell.status.removed": ["Removed", "مُزال"],
  "sell.what": ["What are you selling?", "ماذا تبيع؟"],
  "sell.how": ["How do you want to start?", "كيف تريد أن تبدأ؟"],
  "sell.mode.ai": ["Read it from a screenshot", "اقرأها من لقطة شاشة"],
  "sell.mode.ai.hint": ["Fastest. Take a screenshot of the About screen; we fill in the specs for you to check.", "الأسرع. التقط صورة لشاشة «حول» وسنملأ المواصفات لتراجعها."],
  "sell.mode.manual": ["Enter the details myself", "أدخل التفاصيل بنفسي"],
  "sell.mode.manual.hint": ["Type the brand, model and specs.", "اكتب العلامة والطراز والمواصفات."],
  "sell.start": ["Start", "ابدأ"],

  // Sell — wizard steps
  "wiz.step": ["Step {a} of {b}", "الخطوة {a} من {b}"],
  "wiz.device": ["Your phone", "جوالك"],
  "wiz.specs": ["Device details", "تفاصيل الجهاز"],
  "device.brandQ": ["Which brand is it?", "ما نوع الجوال؟"],
  "device.modelQ": ["Which model?", "ما الموديل؟"],
  "device.storageQ": ["How much storage?", "كم سعة التخزين؟"],
  "device.colorQ": ["Which colour?", "ما اللون؟"],
  "device.search": ["Search, e.g. iPhone 17 Pro", "ابحث، مثل آيفون ١٧ برو"],
  "device.searchModels": ["Search {brand} models", "ابحث في موديلات {brand}"],
  "device.noResults": ["No match. Try fewer words, or type it in yourself.", "لا نتائج. جرّب كلمات أقل، أو اكتبه بنفسك."],
  "device.models": ["{n} models", "{n} موديل"],
  "device.newFrom": ["New from {p}", "جديد من {p}"],
  "device.newPrice": ["New {p}", "جديد {p}"],
  "device.thisPhone": ["Selling this phone?", "تبيع هذا الجوال؟"],
  "device.recent": ["You listed before", "عرضتها من قبل"],
  "device.manual": ["Not in the list? Type it in", "غير موجود في القائمة؟ اكتبه بنفسك"],
  "device.skipColor": ["Skip colour", "تخطَّ اللون"],
  "device.change": ["Change", "تغيير"],
  "device.clear": ["Clear search", "مسح البحث"],
  "device.yourPicks": ["Your choices", "اختياراتك"],
  "device.iphoneTip": ["Not sure which iPhone? Settings › General › About shows the model name.", "لست متأكداً من الموديل؟ تجده في الإعدادات › عام › حول."],
  "device.unavailable": ["The phone list isn't available right now. Enter the details yourself.", "قائمة الجوالات غير متاحة الآن. أدخل التفاصيل بنفسك."],
  "wiz.about": ["About screen", "شاشة «حول»"],

  "about.title": ["Find your device's About screen", "افتح شاشة «حول» في جهازك"],
  "about.cantOpen": ["We can't open settings for you. Follow these steps, take a screenshot, then upload it here.", "لا يمكننا فتح الإعدادات نيابةً عنك. اتبع الخطوات والتقط صورة للشاشة ثم ارفعها هنا."],
  "about.iphone": ["iPhone", "آيفون"],
  "about.iphone.steps": ["Open Settings → General → About. Press the side button and volume up together to take a screenshot.", "افتح الإعدادات ← عام ← حول. اضغط الزر الجانبي وزر رفع الصوت معاً لالتقاط صورة للشاشة."],
  "about.android": ["Android", "أندرويد"],
  "about.android.steps": ["Open Settings → About phone. Press power and volume down together to take a screenshot.", "افتح الإعدادات ← حول الهاتف. اضغط زر التشغيل وزر خفض الصوت معاً لالتقاط صورة للشاشة."],
  "about.windows": ["Windows", "ويندوز"],
  "about.windows.steps": ["Open Settings → System → About. Press Windows + Shift + S to take a screenshot.", "افتح الإعدادات ← النظام ← حول. اضغط Windows + Shift + S لالتقاط صورة للشاشة."],
  "about.mac": ["Mac", "ماك"],
  "about.mac.steps": ["Open the Apple menu → About This Mac. Press Shift + Command + 4, then Space, then click the window.", "افتح قائمة Apple ← حول هذا الماك. اضغط Shift + Command + 4 ثم المسافة ثم انقر على النافذة."],
  "about.photoOk": ["You can also photograph the screen with another phone.", "يمكنك أيضاً تصوير الشاشة بهاتف آخر."],
  "about.private": ["We black out IMEI, serial numbers and account names before anything is read, and never show this image to buyers.", "نُخفي رقم IMEI والأرقام التسلسلية وأسماء الحسابات قبل القراءة، ولا نعرض هذه الصورة للمشترين أبداً."],
  "about.upload": ["Upload screenshot", "ارفع لقطة الشاشة"],
  "about.reading": ["Reading your screenshot…", "نقرأ لقطة الشاشة…"],
  "about.readingHint": ["This usually takes a few seconds.", "يستغرق ذلك عادةً بضع ثوانٍ."],
  "about.done": ["Here's what we read. Check each item.", "هذا ما قرأناه. راجع كل عنصر."],
  "about.redacted": ["{n} private details were blacked out.", "تم إخفاء {n} من البيانات الخاصة."],
  "about.failed": ["We couldn't read that one", "تعذّرت قراءة هذه الصورة"],
  "about.skip": ["Enter details myself instead", "أدخل التفاصيل بنفسي"],
  "about.tryAnother": ["Try another screenshot", "جرّب لقطة أخرى"],
  "about.questions": ["A few quick questions", "أسئلة سريعة"],
  "about.noInvent": ["We only fill in what's on the screen. Condition, battery health and price are yours to answer.", "نملأ فقط ما يظهر على الشاشة. الحالة وصحة البطارية والسعر تحددها أنت."],

  "specs.title": ["What exactly is it?", "ما الجهاز بالضبط؟"],
  "specs.required": ["Required", "مطلوب"],
  "specs.more": ["More details", "تفاصيل إضافية"],
  "specs.colorPick": ["Pick the colour from the maker's list.", "اختر اللون من ألوان الشركة المصنّعة."],
  "specs.locked": ["Brand, model and storage can't change after publishing.", "لا يمكن تغيير العلامة والطراز وسعة التخزين بعد النشر."],
  "specs.example.model.phone": ["e.g. iPhone 13", "مثلاً: iPhone 13"],
  "specs.example.model.laptop": ["e.g. ThinkPad T14 Gen 2", "مثلاً: ThinkPad T14 Gen 2"],
  "specs.example.storage": ["e.g. 128 GB", "مثلاً: 128 GB"],

  "cond.title": ["What condition is it in?", "ما حالة الجهاز؟"],
  "cond.defects": ["Any scratches, cracks or faults?", "هل يوجد خدوش أو كسور أو أعطال؟"],
  "cond.defectsHint": ["Be specific. Honest listings sell faster and avoid returns.", "كن دقيقاً. الإعلانات الصادقة تُباع أسرع وتتجنب الإرجاع."],
  "cond.accessories": ["What's included?", "ماذا يأتي معه؟"],
  "acc.box": ["Original box", "العلبة الأصلية"],
  "acc.charger": ["Charger", "الشاحن"],
  "acc.cable": ["Cable", "الكابل"],
  "acc.case": ["Case", "جراب"],
  "acc.receipt": ["Receipt", "فاتورة الشراء"],
  "acc.earphones": ["Earphones", "سماعات"],
  "cond.description": ["Anything else buyers should know?", "هل هناك ما يجب أن يعرفه المشتري؟"],

  "photos.title": ["Take the photos", "التقط الصور"],
  "photos.next": ["Next: {v}", "التالية: {v}"],
  "photos.take": ["Take photo", "التقط صورة"],
  "photos.retake": ["Retake", "أعد التقاط"],
  "photos.blurry": ["This photo looks blurry. Retake it in good light, or keep it if it's clear to you.", "تبدو هذه الصورة غير واضحة. أعد التقاطها في إضاءة جيدة، أو احتفظ بها إن كانت واضحة."],
  "photos.keep": ["Keep it", "احتفظ بها"],
  "photos.allDone": ["All the photos we need are in.", "اكتملت كل الصور المطلوبة."],
  "photos.addMore": ["Add another photo", "أضف صورة أخرى"],
  "photos.uploading": ["Uploading…", "جارٍ الرفع…"],
  "photos.tips": ["Plain background, daylight, whole device in frame.", "خلفية بسيطة، ضوء النهار، الجهاز كاملاً داخل الإطار."],
  "photos.damageHint": ["You mentioned damage, so add a close-up of it.", "ذكرت وجود ضرر، لذا أضف صورة قريبة له."],
  "view.front": ["Front", "الأمام"],
  "view.back": ["Back", "الخلف"],
  "view.left": ["Left side", "الجانب الأيسر"],
  "view.right": ["Right side", "الجانب الأيمن"],
  "view.screen_on": ["Screen on", "الشاشة مضاءة"],
  "view.lid": ["Lid closed", "الغطاء مغلق"],
  "view.keyboard": ["Keyboard", "لوحة المفاتيح"],
  "view.ports_left": ["Left ports", "المنافذ اليسرى"],
  "view.ports_right": ["Right ports", "المنافذ اليمنى"],
  "view.bottom": ["Underside", "الجهة السفلية"],
  "view.damage": ["Damage close-up", "صورة قريبة للضرر"],
  "view.other": ["Extra", "إضافية"],
  "hint.front": ["Screen facing the camera, phone switched off, on a plain surface.", "الشاشة مقابل الكاميرا، الهاتف مطفأ، على سطح بسيط."],
  "hint.back": ["Whole back in frame, including the camera bump.", "الجهة الخلفية كاملة مع بروز الكاميرا."],
  "hint.left": ["Hold it edge-on so the buttons are visible.", "أمسكه من الحافة لتظهر الأزرار."],
  "hint.right": ["The other edge, buttons and SIM tray visible.", "الحافة الأخرى مع الأزرار ودرج الشريحة."],
  "hint.screen_on": ["Switched on, showing the home screen at full brightness.", "مُشغّل ويعرض الشاشة الرئيسية بأعلى سطوع."],
  "hint.lid": ["Top of the lid, whole laptop in frame.", "أعلى الغطاء، اللابتوب كاملاً داخل الإطار."],
  "hint.keyboard": ["Straight down onto the keyboard and trackpad.", "من الأعلى مباشرة على لوحة المفاتيح ولوحة اللمس."],
  "hint.ports_left": ["Left edge, so every port is visible.", "الحافة اليسرى لتظهر كل المنافذ."],
  "hint.ports_right": ["Right edge, so every port is visible.", "الحافة اليمنى لتظهر كل المنافذ."],
  "hint.bottom": ["Flip it over; include feet and labels. We hide serial numbers.", "اقلبه وأظهر الأرجل والملصقات. نُخفي الأرقام التسلسلية."],
  "hint.damage": ["Close-up of each scratch, crack or dent you mentioned.", "صورة قريبة لكل خدش أو كسر أو انبعاج ذكرته."],

  "price.title": ["Set your price", "حدّد السعر"],
  "price.asking": ["Your price", "سعرك"],
  "price.quantity": ["How many do you have?", "كم قطعة لديك؟"],
  "price.city": ["Where buyers can meet you", "أين يقابلك المشتري"],
  "price.delivery": ["I can also deliver", "أستطيع التوصيل أيضاً"],
  "price.deliveryFee": ["Delivery charge", "رسوم التوصيل"],

  "preview.publish": ["Publish listing", "انشر الإعلان"],
  "preview.publishing": ["Publishing…", "جارٍ النشر…"],
  "preview.confirm": ["I confirm these details are accurate and I own this device.", "أؤكد أن هذه التفاصيل صحيحة وأنني أملك هذا الجهاز."],
  "preview.missing": ["Before you publish", "قبل النشر"],
  "preview.published": ["Published", "تم النشر"],
  "preview.publishedBody": ["It's live. Buyers will message you or open your WhatsApp; every conversation lands in Deals.", "إعلانك منشور. سيراسلك المشترون أو يفتحون واتساب، وكل محادثة تصل إلى «الصفقات»."],
  "preview.view": ["View listing", "عرض الإعلان"],
  "preview.saveDraft": ["Save draft and exit", "احفظ المسودة واخرج"],
  "ready.spec_missing": ["Add the {f}.", "أضف {f}."],
  "ready.spec_color": ["Pick a colour this model comes in.", "اختر لوناً يتوفر به هذا الطراز."],
  "ready.spec_unconfirmed": ["Confirm the {f}: {v}", "أكّد {f}: {v}"],
  "ready.condition_missing": ["Choose the condition.", "اختر الحالة."],
  "ready.price_missing": ["Set your asking price.", "حدّد السعر المطلوب."],
  "ready.city_missing": ["Add your city.", "أضف مدينتك."],
  "ready.fulfillment_missing": ["Offer pickup, delivery, or both.", "اختر الاستلام أو التوصيل أو كليهما."],
  "ready.photo_missing": ["Add a photo: {v}.", "أضف صورة: {v}."],

  // Manage listing (seller)
  "manage.pause": ["Pause listing", "إيقاف الإعلان"],
  "manage.resume": ["Resume listing", "استئناف الإعلان"],
  "manage.editDetails": ["Edit details", "تعديل التفاصيل"],

  // Inbox
  "inbox.you": ["You", "أنت"],
  "inbox.placeholder": ["Write a message", "اكتب رسالة"],
  "inbox.send": ["Send", "إرسال"],
  "inbox.masked": ["Typed numbers are hidden to keep you both safe. Use \"Share my number\" to share yours on purpose.", "نُخفي الأرقام المكتوبة لحمايتكما. استخدم «شارك رقمي» لمشاركة رقمك بقصد."],
  "inbox.buying": ["Buying", "شراء"],
  "inbox.selling": ["Selling", "بيع"],
  "inbox.reportMessage": ["Report", "إبلاغ"],

  // Account
  "account.title": ["Account", "الحساب"],
  "account.name": ["Display name", "الاسم الظاهر"],
  "account.nameHint": ["Shown to buyers and sellers on listings and in deals.", "يظهر للبائعين والمشترين في الإعلانات والصفقات."],
  "account.city": ["City", "المدينة"],
  "account.phone": ["Mobile", "الجوال"],
  "account.email": ["E-mail", "البريد الإلكتروني"],

  // Profile (Account page)
  "profile.since": ["Member since {d}", "عضو منذ {d}"],
  "profile.emailVerified": ["E-mail verified", "البريد موثّق"],
  "profile.phoneVerified": ["Mobile verified", "الجوال موثّق"],
  "profile.complete": ["Complete your profile", "أكمل ملفك"],
  "profile.progress": ["{n} of {total}", "{n} من {total}"],
  "profile.whyComplete": ["A complete profile gets more replies, and more buyers when you sell.", "الملف المكتمل يحصل على ردود أكثر، ومشترين أكثر عندما تبيع."],
  "profile.allSet": ["Your profile is complete.", "ملفك مكتمل."],
  "profile.step.name": ["Add your name", "أضف اسمك"],
  "profile.step.city": ["Choose your city", "اختر مدينتك"],
  "profile.step.email": ["Add an e-mail", "أضف بريداً إلكترونياً"],
  "profile.step.phone": ["Add a mobile number", "أضف رقم جوال"],
  "profile.public": ["Public profile", "الملف العام"],
  "profile.notAdded": ["Not added", "غير مضاف"],
  "profile.edit": ["Edit", "تعديل"],
  "profile.cancel": ["Cancel", "إلغاء"],
  "profile.add": ["Add", "إضافة"],
  "profile.verify": ["Verify", "تحقّق"],
  "profile.verified": ["Verified", "موثّق"],
  "profile.nameHint": ["Your name or shop name. People see it on listings, in deals and on reviews.", "اسمك أو اسم متجرك. يراه الناس في الإعلانات والصفقات والتقييمات."],
  "profile.nameShort": ["Use at least 2 characters.", "استخدم حرفين على الأقل."],
  "profile.nameContact": ["Leave phone numbers and e-mails out of your name.", "لا تضع أرقام جوال أو بريداً إلكترونياً في اسمك."],
  "profile.cityHint": ["Helps buyers near you find your listings for pickup.", "يساعد المشترين القريبين منك على إيجاد إعلاناتك للاستلام."],
  "profile.chooseCity": ["Choose a city", "اختر مدينة"],
  "profile.shownAs": ["Shown as", "يظهر باسم"],
  "profile.contact": ["Sign-in and contact", "الدخول والتواصل"],
  "profile.contactWhy": ["You sign in with either one, and we send deal updates there. Never shown to other people.", "تسجّل الدخول بأيٍّ منهما، ونرسل إليه تحديثات الصفقات. لا يظهر لأي شخص آخر."],
  "profile.contactAdded": ["Added and verified", "تمت الإضافة والتوثيق"],
  "profile.more": ["More", "المزيد"],
  "profile.tab.profile": ["Profile", "الملف"],
  "profile.tab.settings": ["Settings", "الإعدادات"],

  "reauth.title": ["Confirm it's you", "أكّد أنك أنت"],
  "reauth.intro": ["For your security, enter the code we sent to {to}.", "لحماية حسابك، أدخل الرمز الذي أرسلناه إلى {to}."],
  "reauth.confirm": ["Confirm", "تأكيد"],
  "account.favorites": ["Saved items", "المحفوظات"],
  "account.notifications": ["Notifications", "الإشعارات"],
  "account.signOut": ["Sign out", "تسجيل الخروج"],
  "account.verify": ["Request seller verification", "اطلب توثيق البائع"],
  "account.verifyPending": ["Verification requested", "طلب التوثيق قيد المراجعة"],
  "account.verified": ["Verified seller", "بائع موثّق"],
  "account.staff": ["Staff tools", "أدوات الفريق"],
  "account.admin": ["Open admin", "افتح لوحة الإدارة"],
  "fav.empty": ["Nothing saved yet", "لا توجد محفوظات"],
  "fav.emptyBody": ["Tap the heart on a listing to keep it here. If its price drops, we'll tell you.", "اضغط على القلب في أي إعلان لحفظه هنا. وإذا انخفض سعره سنخبرك."],
  "fav.unavailable": ["No longer available", "لم يعد متاحاً"],
  "notif.empty": ["You're all caught up", "لا جديد"],
  "notif.markRead": ["Mark all as read", "تحديد الكل كمقروء"],

  // MFA
  "mfa.title": ["Verify it's you", "تحقق من هويتك"],
  "mfa.body": ["Staff tools need a code from your authenticator app.", "تتطلب أدوات الفريق رمزاً من تطبيق المصادقة."],
  "mfa.setup": ["Set up authenticator", "إعداد تطبيق المصادقة"],
  "mfa.secret": ["Add this key to Google Authenticator, 1Password or similar:", "أضف هذا المفتاح إلى Google Authenticator أو 1Password أو تطبيق مشابه:"],
  "mfa.code": ["6-digit code", "رمز من 6 أرقام"],
  "mfa.verify": ["Verify", "تحقق"],

  // Direct marketplace: listing, contact, trust
  "nav.deals": ["Deals", "الصفقات"],
  "nav.saved": ["Saved", "المحفوظات"],
  "verdict.great": ["Great price", "سعر ممتاز"],
  "verdict.fair": ["Fair price", "سعر مناسب"],
  "verdict.high": ["Above market", "أعلى من السوق"],
  "guide.title": ["Market price", "سعر السوق"],
  "guide.forThis": ["What this phone sells for", "بكم يُباع هذا الجوال"],
  "guide.typical": ["Typical {p}", "المعتاد {p}"],
  "guide.basis": ["From {l} listings and {d} completed deals", "من {l} إعلان و{d} صفقة مكتملة"],
  "guide.basisNew": ["Estimated from the price new", "تقدير من سعره جديداً"],
  "guide.estimate": ["estimate", "تقديري"],
  "trust.badges": ["Track record", "السجل"],
  "trust.replyMin": ["Usually replies within {n} min", "يرد عادةً خلال {n} دقيقة"],
  "trust.replyHours": ["Usually replies within {n} h", "يرد عادةً خلال {n} ساعة"],
  "trust.sales": ["{n} sales", "{n} عملية بيع"],
  "trust.new": ["New on Walashy", "جديد في Walashy"],
  "badge.verified_shop": ["Verified shop", "متجر موثّق"],
  "badge.verified_shop.hint": ["Walashy checked this shop's business details.", "تحقق Walashy من بيانات هذا المتجر."],
  "badge.verified_number": ["Verified number", "رقم موثّق"],
  "badge.verified_number.hint": ["Their mobile number was confirmed with a code.", "تم تأكيد رقم جواله برمز تحقق."],
  "badge.fast_reply": ["Replies fast", "يرد بسرعة"],
  "badge.fast_reply.hint": ["Answers most messages within an hour.", "يرد على معظم الرسائل خلال ساعة."],
  "badge.trusted": ["Trusted seller", "بائع موثوق"],
  "badge.trusted.hint": ["Three or more completed sales, rated 4.5 or higher.", "ثلاث صفقات مكتملة أو أكثر بتقييم ٤٫٥ أو أعلى."],
  "contact.whatsapp": ["WhatsApp", "واتساب"],
  "contact.call": ["Call", "اتصال"],
  "contact.whatsappOk": ["Reachable on WhatsApp", "متاح على واتساب"],
  "contact.numberVerified": ["Verified number", "رقم موثّق"],
  "contact.numberUnverified": ["Number not verified by Walashy", "رقم غير موثّق من Walashy"],
  "contact.dealSaved": ["Saved in your deals", "محفوظ في صفقاتك"],
  "listing.was": ["Was {p}", "كان {p}"],
  "listing.negotiable": ["Negotiable", "قابل للتفاوض"],
  "listing.fixed": ["Fixed price", "سعر نهائي"],
  "listing.reserved": ["Reserved", "محجوز"],
  "listing.reservedHint": ["Reserved for another buyer. Message the seller in case it falls through.", "محجوز لمشترٍ آخر. راسل البائع في حال لم تكتمل الصفقة."],
  "listing.continueDeal": ["Continue your deal", "تابع صفقتك"],
  "listing.findSimilar": ["Find similar phones", "ابحث عن جوالات مشابهة"],
  "listing.meetIn": ["Meet the seller in {city}", "قابل البائع في {city}"],
  "listing.canDeliver": ["The seller can also deliver ({fee})", "يمكن للبائع التوصيل أيضاً ({fee})"],
  "listing.meetOnly": ["Agree on a public place to meet", "اتفقا على مكان عام للقاء"],
  "listing.direct": ["No fees. You pay the seller directly once you've checked the phone. Walashy never holds your money.", "بدون أي رسوم. تدفع للبائع مباشرة بعد فحص الجوال. Walashy لا يحتفظ بأموالك أبداً."],
  "listing.noFees": ["No fees · pay the seller directly", "بدون رسوم · الدفع للبائع مباشرة"],
  "listing.share": ["Share", "مشاركة"],
  "listing.linkCopied": ["Link copied", "تم نسخ الرابط"],
  "listing.views": ["Viewed {n} times", "شوهد {n} مرة"],
  "ask.title": ["Message {name}", "راسل {name}"],
  "ask.available": ["Hi, is it still available?", "السلام عليكم، هل ما زال متوفراً؟"],
  "ask.seeToday": ["Can I see it today?", "أقدر أشوفه اليوم؟"],
  "ask.battery": ["What's the battery health?", "كم نسبة صحة البطارية؟"],
  "ask.bestPrice": ["What's your best price?", "كم آخر سعر؟"],
  "ask.message": ["Your message", "رسالتك"],
  "ask.withPrice": ["Propose a price too", "اقترح سعراً أيضاً"],
  "ask.asking": ["Asking {p}", "المطلوب {p}"],
  "ask.note": ["Your number stays private unless you choose to share it.", "رقمك يبقى خاصاً إلا إذا اخترت مشاركته."],
  "ask.send": ["Send", "إرسال"],
  "safety.open": ["How to buy safely", "كيف تشتري بأمان"],
  "safety.title": ["Buy safely, in person", "اشترِ بأمان وجهاً لوجه"],
  "safety.intro": ["You and the seller deal directly. These six habits keep it safe.", "أنت والبائع تتعاملان مباشرة. هذه العادات الست تحميك."],
  "safety.public": ["Meet in a busy public place in daylight, like a mall entrance.", "تقابلا في مكان عام مزدحم وفي النهار، مثل مدخل مجمع تجاري."],
  "safety.imei": ["Dial *#06# and check the IMEI matches the box and the settings.", "اطلب ‎*#06#‎ وتأكد أن رقم IMEI يطابق العلبة والإعدادات."],
  "safety.accounts": ["Make sure iCloud or Google is signed out and Find My is off.", "تأكد من تسجيل الخروج من iCloud أو Google وإيقاف «تحديد الموقع»."],
  "safety.test": ["Test the screen, cameras, speakers, charging and a call with your SIM.", "جرّب الشاشة والكاميرات والسماعات والشحن ومكالمة بشريحتك."],
  "safety.payAfter": ["Pay only after checking, and never transfer money in advance.", "ادفع بعد الفحص فقط، ولا تحوّل أي مبلغ مسبقاً."],
  "safety.receipt": ["Both confirm the handover in Walashy to get a bill of sale.", "أكّدا التسليم في Walashy لتحصلا على عقد بيع."],

  // Direct marketplace: deals
  "next.answerPrice": ["{name} offers {p}", "{name} يعرض {p}"],
  "next.answerPriceBody": ["Your asking price is {asking}. Accept, answer with your price, or decline.", "سعرك المطلوب {asking}. اقبل، أو رُدّ بسعرك، أو ارفض."],
  "next.waitingPrice": ["Waiting for {name} to answer your {p}", "بانتظار رد {name} على سعرك {p}"],
  "next.waitingPriceBody": ["You'll get a notification. Meanwhile you can keep chatting.", "سيصلك إشعار. وفي الأثناء يمكنكما متابعة المحادثة."],
  "deals.title": ["Deals", "الصفقات"],
  "deals.role.all": ["All", "الكل"],
  "deals.role.buying": ["Buying", "أشتري"],
  "deals.role.selling": ["Selling", "أبيع"],
  "deals.state.active": ["In progress", "جارية"],
  "deals.state.done": ["Done", "منتهية"],
  "deals.empty": ["No deals in progress", "لا توجد صفقات جارية"],
  "deals.emptyDone": ["No finished deals yet", "لا توجد صفقات منتهية بعد"],
  "deals.emptyBody": ["Message a seller, or open their WhatsApp from a listing. Every conversation is kept here as a deal, from the first question to the handover.", "راسل بائعاً أو افتح واتساب من أي إعلان. كل محادثة تُحفظ هنا كصفقة، من أول سؤال حتى التسليم."],
  "deal.status.open": ["Talking", "تواصل"],
  "deal.status.agreed": ["Price agreed", "تم الاتفاق على السعر"],
  "deal.status.reserved": ["Reserved", "محجوز"],
  "deal.status.completed": ["Completed", "مكتملة"],
  "deal.status.cancelled": ["Cancelled", "ملغاة"],
  "deal.source.whatsapp": ["via WhatsApp", "عبر واتساب"],
  "deal.source.call": ["via call", "عبر اتصال"],
  "needs.answer_price": ["Answer the price", "رُدّ على السعر"],
  "needs.confirm_received": ["Confirm you received it", "أكّد الاستلام"],
  "needs.confirm_handover": ["Confirm the handover", "أكّد التسليم"],
  "needs.reply": ["Waiting for your reply", "بانتظار ردك"],
  "msg.youProposed": ["You proposed {p}", "اقترحتَ {p}"],
  "msg.theyProposed": ["Proposed {p}", "اقترح {p}"],
  "msg.sharedWhatsapp": ["Shared a WhatsApp number", "شارك رقم واتساب"],
  "msg.sharedNumber": ["Shared a phone number", "شارك رقم جوال"],
  "event.contact_opened": ["Opened WhatsApp or a call", "فتح واتساب أو اتصل"],
  "event.contact_opened.seller": ["The buyer took your number to reach you on {method}", "أخذ المشتري رقمك للتواصل عبر {method}"],
  "event.contact_opened.buyer": ["You took the seller's number for {method}", "أخذتَ رقم البائع للتواصل عبر {method}"],
  "event.agreed": ["Price agreed: {p}", "تم الاتفاق على السعر: {p}"],
  "event.meetup": ["Meetup: {place}", "اللقاء: {place}"],
  "event.reserved": ["The seller reserved it for this buyer", "حجزه البائع لهذا المشتري"],
  "event.seller_confirmed": ["The seller confirmed the handover", "أكّد البائع التسليم"],
  "event.buyer_confirmed": ["The buyer confirmed receiving it", "أكّد المشتري الاستلام"],
  "event.completed": ["Deal completed by both sides", "اكتملت الصفقة بتأكيد الطرفين"],
  "event.cancelled": ["{who} cancelled the deal", "ألغى {who} الصفقة"],
  "deal.aboutBuyer": ["Buyer:", "المشتري:"],
  "deal.aboutSeller": ["Seller:", "البائع:"],
  "deal.profile": ["Profile", "الملف"],
  "trust.purchases": ["{n} purchases", "{n} عملية شراء"],
  "deal.progress": ["Deal progress", "مراحل الصفقة"],
  "deal.step.contact": ["Contact", "تواصل"],
  "deal.step.price": ["Price", "السعر"],
  "deal.step.reserved": ["Meet", "اللقاء"],
  "deal.step.handover": ["Handover", "التسليم"],
  "deal.step.done": ["Done", "تمّت"],
  "deal.tools": ["Deal tools", "أدوات الصفقة"],
  "deal.propose": ["Propose a price", "اقترح سعراً"],
  "deal.counter": ["Counter-offer", "سعر مقابل"],
  "deal.meetup": ["Plan the meetup", "حدّد موعد اللقاء"],
  "deal.checklist": ["Handover checklist", "قائمة فحص الاستلام"],
  "deal.checklistN": ["Checks {n}/{total}", "الفحص {n}/{total}"],
  "deal.shareNumber": ["Share my number", "شارك رقمي"],
  "deal.cancel": ["Cancel deal", "إلغاء الصفقة"],
  "deal.cancelTitle": ["Cancel this deal?", "إلغاء هذه الصفقة؟"],
  "deal.cancelBody": ["The conversation stays, but the deal ends. You can always start a new one.", "تبقى المحادثة، لكن الصفقة تنتهي. يمكنك دائماً بدء صفقة جديدة."],
  "deal.cancelReserved": ["The reservation ends and the phone goes back on sale.", "ينتهي الحجز ويعود الجوال للبيع."],
  "deal.cancelReason": ["Reason (optional, the other person sees it)", "السبب (اختياري، يراه الطرف الآخر)"],
  "deal.cancelled": ["Deal cancelled", "أُلغيت الصفقة"],
  "deal.reserve": ["Reserve for this buyer", "احجزه لهذا المشتري"],
  "deal.reserveAt": ["Reserve at {p}", "احجزه بسعر {p}"],
  "deal.reservedToast": ["Reserved. It's off the market until you complete or cancel.", "تم الحجز. لن يظهر للبيع حتى تكمل الصفقة أو تلغيها."],
  "deal.receipt": ["Bill of sale", "عقد البيع"],
  "deal.reviewedDone": ["You've left a review", "قيّمت هذه الصفقة"],
  "deal.confirmHandover": ["I handed it over", "سلّمت الجهاز"],
  "deal.confirmReceived": ["I received it", "استلمت الجهاز"],
  "deal.confirmHandoverTitle": ["Confirm the handover?", "تأكيد التسليم؟"],
  "deal.confirmReceivedTitle": ["Confirm you received it?", "تأكيد الاستلام؟"],
  "deal.confirmHandoverBody": ["Confirm once the buyer has the phone and you've been paid {total}. It comes off your listing for good.", "أكّد بعد أن يستلم المشتري الجوال وتستلم {total}. سيُزال من إعلانك نهائياً."],
  "deal.confirmReceivedBody": ["Confirm once you have the phone, it matches the listing, and you've paid the seller {total} directly.", "أكّد بعد استلام الجوال ومطابقته للإعلان ودفعك {total} للبائع مباشرة."],
  "deal.confirmed": ["Confirmed", "تم التأكيد"],
  "deal.proposalSent": ["Price sent", "أُرسل السعر"],
  "deal.meetupSent": ["Meetup sent", "أُرسل موعد اللقاء"],
  "deal.numberShared": ["Number shared in this deal", "تمت مشاركة رقمك في الصفقة"],
  "deal.directNote": ["You pay each other directly. Walashy keeps the record, free.", "الدفع بينكما مباشرة. Walashy يحفظ السجل مجاناً."],
  "deal.completedOn": ["Completed {d}", "اكتملت في {d}"],
  "next.cancelledByYou": ["You cancelled this deal", "ألغيتَ هذه الصفقة"],
  "next.cancelledByThem": ["This deal was cancelled", "أُلغيت هذه الصفقة"],
  "next.completed": ["Deal completed", "اكتملت الصفقة"],
  "next.completedBody": ["Both of you confirmed the handover for {total}. Your bill of sale is ready.", "أكّدتما التسليم بمبلغ {total}. عقد البيع جاهز."],
  "next.sellerBuyerConfirmed": ["The buyer says they have it", "المشتري يقول إنه استلمه"],
  "next.sellerBuyerConfirmedBody": ["Confirm the handover to complete the deal and get your bill of sale.", "أكّد التسليم لإتمام الصفقة والحصول على عقد البيع."],
  "next.buyerSellerConfirmed": ["The seller says it's handed over", "البائع يقول إنه سلّمه"],
  "next.buyerSellerConfirmedBody": ["Have it, checked it, and paid {total}? Confirm to complete. If something's wrong, don't confirm: tell the seller, or report it.", "استلمته وفحصته ودفعت {total}؟ أكّد لإتمام الصفقة. إن كان هناك خطأ فلا تؤكد: أخبر البائع أو أبلغنا."],
  "next.waitingBuyer": ["Waiting for the buyer to confirm", "بانتظار تأكيد المشتري"],
  "next.waitingSeller": ["Waiting for the seller to confirm", "بانتظار تأكيد البائع"],
  "next.sellerReserved": ["Reserved for this buyer", "محجوز لهذا المشتري"],
  "next.sellerReservedBody": ["Meet, let them check it, get paid {total}, then confirm the handover.", "قابل المشتري ودعه يفحص الجوال، واستلم {total}، ثم أكّد التسليم."],
  "next.buyerReserved": ["It's held for you", "محجوز لك"],
  "next.buyerReservedBody": ["Meet the seller, go through the checklist, pay {total} directly, then confirm.", "قابل البائع، وراجع قائمة الفحص، وادفع {total} مباشرة، ثم أكّد."],
  "next.agreed": ["Price agreed: {total}", "تم الاتفاق على السعر: {total}"],
  "next.agreedSellerBody": ["Agree where to meet, and reserve it so no one else takes it.", "اتفقا على مكان اللقاء، واحجزه حتى لا يأخذه غيره."],
  "next.agreedBuyerBody": ["Agree where and when to meet. The seller can reserve it for you.", "اتفقا على مكان وموعد اللقاء. يمكن للبائع حجزه لك."],
  "next.openSeller": ["A buyer is interested", "مشترٍ مهتم"],
  "next.openSellerBody": ["Answer their questions. When you agree, reserve it for them.", "أجب عن أسئلته. وعند الاتفاق احجزه له."],
  "next.openBuyer": ["Talk to the seller", "تحدّث مع البائع"],
  "next.openBuyerBody": ["Ask what you need to know. You can propose a price here too.", "اسأل عمّا تحتاج معرفته. ويمكنك اقتراح سعر من هنا."],
  "proposal.yours": ["Your price", "سعرك"],
  "proposal.theirs": ["{name}'s price", "سعر {name}"],
  "proposal.qty": ["{q} × {p}", "{q} × {p}"],
  "proposal.status.open": ["Waiting for an answer", "بانتظار الرد"],
  "proposal.status.accepted": ["Accepted", "مقبول"],
  "proposal.status.declined": ["Declined", "مرفوض"],
  "proposal.status.withdrawn": ["Withdrawn", "مسحوب"],
  "proposal.status.replaced": ["Replaced", "استُبدل"],
  "proposal.accept": ["Accept", "قبول"],
  "proposal.decline": ["Decline", "رفض"],
  "proposal.withdraw": ["Withdraw", "سحب"],
  "proposal.total": ["Total {p}", "الإجمالي {p}"],
  "proposal.send": ["Send price", "أرسل السعر"],
  "proposal.explain": ["A price is an offer in the conversation. Nothing is charged; if the other side accepts, it becomes the agreed price.", "السعر عرض داخل المحادثة. لا يُخصم أي مبلغ؛ وإذا قبله الطرف الآخر يصبح السعر المتفق عليه."],
  "proposal.price": ["Price per phone", "السعر للجهاز"],
  "meet.public": ["Choose a busy public place. Daytime is best.", "اختر مكاناً عاماً مزدحماً. النهار أفضل."],
  "meet.mall": ["Mall main entrance", "المدخل الرئيسي للمجمع التجاري"],
  "meet.cafe": ["A coffee shop", "مقهى"],
  "meet.shop": ["The seller's shop", "متجر البائع"],
  "meet.station": ["Petrol station with a shop", "محطة وقود فيها متجر"],
  "meet.place": ["Where", "المكان"],
  "meet.when": ["When", "الموعد"],
  "meet.send": ["Send", "إرسال"],
  "check.intro": ["Tick each one at the handover, before you pay. It's saved on your bill of sale.", "أشّر على كل بند عند الاستلام وقبل الدفع. يُحفظ في عقد البيع."],
  "check.imei_match": ["IMEI matches", "رقم IMEI مطابق"],
  "check.imei_match.how": ["Dial *#06#; compare with the box and Settings.", "اطلب ‎*#06#‎ وقارنه بالعلبة والإعدادات."],
  "check.accounts_removed": ["Accounts signed out", "الحسابات مسجّل خروجها"],
  "check.accounts_removed.how": ["iCloud or Google signed out, Find My off.", "تسجيل الخروج من iCloud أو Google وإيقاف «تحديد الموقع»."],
  "check.screen_touch": ["Screen and touch", "الشاشة واللمس"],
  "check.screen_touch.how": ["No dead spots, lines or burn-in.", "لا بقع ميتة أو خطوط أو احتراق."],
  "check.cameras": ["Cameras", "الكاميرات"],
  "check.cameras.how": ["Front and back, photo and video.", "الأمامية والخلفية، صور وفيديو."],
  "check.battery": ["Battery health", "صحة البطارية"],
  "check.battery.how": ["Settings → Battery; matches the listing.", "الإعدادات ← البطارية؛ مطابقة للإعلان."],
  "check.charging": ["Charging", "الشحن"],
  "check.charging.how": ["Plug it in; it charges.", "وصّله بالشاحن وتأكد أنه يشحن."],
  "check.biometrics": ["Face ID / fingerprint", "بصمة الوجه / الإصبع"],
  "check.biometrics.how": ["Set it up and unlock once.", "فعّلها وافتح الجهاز مرة."],
  "check.sim_calls": ["SIM and calls", "الشريحة والمكالمات"],
  "check.sim_calls.how": ["Your SIM works; make a quick call.", "شريحتك تعمل؛ أجرِ مكالمة قصيرة."],
  "share.explain": ["Posts your number in this deal so you can continue on WhatsApp or by phone. Only this person sees it.", "يضع رقمك في هذه الصفقة لتكملا على واتساب أو بالاتصال. لا يراه إلا هذا الشخص."],
  "share.whatsapp": ["Share for WhatsApp", "شارك للتواصل عبر واتساب"],
  "share.call": ["Share for calls", "شارك للاتصال"],
  "share.manage": ["Change your contact number", "غيّر رقم التواصل"],
  "review.rate": ["Rate {name}", "قيّم {name}"],
  "review.body": ["How did it go? (optional)", "كيف كانت التجربة؟ (اختياري)"],
  "review.post": ["Post review", "انشر التقييم"],
  "review.thanks": ["Thanks for the review", "شكراً على التقييم"],

  // Direct marketplace: receipts, saved
  "receipt.title": ["Bill of sale", "عقد البيع"],
  "receipt.print": ["Print or save as PDF", "اطبع أو احفظ PDF"],
  "receipt.seller": ["Seller", "البائع"],
  "receipt.buyer": ["Buyer", "المشتري"],
  "receipt.price": ["Agreed price", "السعر المتفق عليه"],
  "receipt.payment": ["Payment", "الدفع"],
  "receipt.paidDirectly": ["Paid directly between buyer and seller", "دُفع مباشرة بين المشتري والبائع"],
  "receipt.where": ["Handover", "مكان التسليم"],
  "receipt.sellerConfirmed": ["Seller confirmed", "تأكيد البائع"],
  "receipt.buyerConfirmed": ["Buyer confirmed", "تأكيد المشتري"],
  "receipt.verify": ["Anyone can check this bill of sale at", "يمكن لأي شخص التحقق من هذا العقد عبر"],
  "receipt.disclaimer": ["Walashy recorded both confirmations. It did not inspect the device or handle the payment.", "سجّل Walashy تأكيد الطرفين، ولم يفحص الجهاز أو يتعامل مع المبلغ."],
  "receiptCheck.title": ["Check a bill of sale", "التحقق من عقد بيع"],
  "receiptCheck.valid": ["This is a real Walashy bill of sale", "هذا عقد بيع حقيقي من Walashy"],
  "receiptCheck.between": ["Between {s} (seller) and {b} (buyer)", "بين {s} (البائع) و{b} (المشتري)"],
  "receiptCheck.invalid": ["No bill of sale with this code", "لا يوجد عقد بيع بهذا الرمز"],
  "receiptCheck.invalidBody": ["Check the 10-character code on the document.", "تحقق من الرمز المكوّن من ١٠ خانات في المستند."],
  "saved.title": ["Saved", "المحفوظات"],
  "saved.phones": ["Phones", "الجوالات"],
  "saved.searches": ["Searches and alerts", "البحث والتنبيهات"],
  "saved.dropped": ["{p} cheaper since you saved it", "أرخص بـ {p} منذ حفظته"],
  "saved.noSearches": ["No saved searches", "لا يوجد بحث محفوظ"],
  "saved.noSearchesBody": ["Search for a phone, then tap \"Alert me\". We'll tell you the moment a match is listed.", "ابحث عن جوال ثم اضغط «نبّهني». سنخبرك فور عرض جوال مطابق."],
  "saved.lastAlert": ["Last match {d}", "آخر تطابق {d}"],
  "saved.noAlertYet": ["No matches yet. We'll tell you.", "لا تطابق بعد. سنخبرك."],
  "saved.alerts": ["Alerts", "التنبيهات"],
  "saved.deleted": ["Search deleted", "حُذف البحث"],

  // Direct marketplace: seller tools
  "sell.free": ["Listing and selling on Walashy is free: no fees, no commission. Buyers pay you directly.", "العرض والبيع في Walashy مجاني: بلا رسوم ولا عمولة. المشتري يدفع لك مباشرة."],
  "sell.status.reserved": ["Reserved", "محجوز"],
  "sell.status.expired": ["Expired", "منتهي"],
  "dash.live": ["Live", "معروض"],
  "dash.reservedN": ["+{n} reserved", "+{n} محجوز"],
  "dash.views7d": ["Views, 7 days", "المشاهدات، ٧ أيام"],
  "dash.views30d": ["{n} in 30 days", "{n} خلال ٣٠ يوماً"],
  "dash.leads": ["Buyers in touch, 30 days", "مشترون تواصلوا، ٣٠ يوماً"],
  "dash.saves": ["{n} saves", "{n} حفظ"],
  "dash.sold30d": ["Sold, 30 days", "مُباع، ٣٠ يوماً"],
  "dash.yourRecord": ["Your track record", "سجلّك"],
  "dash.publicProfile": ["See your public profile", "شاهد ملفك العام"],
  "dash.fastTip": ["Reply within an hour to earn the \"Replies fast\" badge.", "رُدّ خلال ساعة لتحصل على شارة «يرد بسرعة»."],
  "dash.needsYou": ["Waiting for you ({n})", "بانتظارك ({n})"],
  "dash.listings": ["Your listings", "إعلاناتك"],
  "dash.openDeals": ["{n} deals", "{n} صفقة"],
  "dash.expires": ["Expires {d}", "ينتهي {d}"],
  "tools.title": ["Listing tools", "أدوات الإعلان"],
  "tools.bump": ["Move to top", "ارفع للأعلى"],
  "tools.bumped": ["Moved to the top, and renewed for another month", "رُفع للأعلى وجُدّد لشهر آخر"],
  "tools.bumpAt": ["Next free bump {d}", "الرفع المجاني التالي {d}"],
  "tools.renew": ["Renew for free", "جدّد مجاناً"],
  "tools.renewed": ["Live again", "عاد للعرض"],
  "tools.paused": ["Paused", "تم الإيقاف"],
  "tools.expiresOn": ["Live until {d}. Renewing or bumping extends it.", "معروض حتى {d}. التجديد أو الرفع يمدّده."],
  "tools.soldElsewhere": ["Sold outside Walashy", "بِيع خارج Walashy"],
  "tools.soldElsewhereBody": ["Takes these units off the market. Deals made in Walashy are counted for you automatically.", "يزيل هذه القطع من العرض. الصفقات داخل Walashy تُحسب تلقائياً."],
  "tools.markSold": ["Mark as sold", "حدّده كمُباع"],
  "tools.soldDone": ["Marked as sold", "تم التحديد كمُباع"],
  "tools.tips": ["Sell it faster", "بِعه أسرع"],
  "tools.performance": ["How it's doing", "أداء الإعلان"],
  "tools.views": ["Views", "المشاهدات"],
  "tools.views7d": ["{n} this week", "{n} هذا الأسبوع"],
  "tools.saves": ["Saves", "الحفظ"],
  "tools.chats": ["Chats", "المحادثات"],
  "tools.direct": ["Direct", "مباشر"],
  "tools.shares": ["{n} shares", "{n} مشاركة"],
  "tools.chartLabel": ["Views and buyer contacts over the last 14 days", "المشاهدات وتواصل المشترين خلال آخر ١٤ يوماً"],
  "tools.days14": ["Last 14 days", "آخر ١٤ يوماً"],
  "tools.leadsKey": ["Buyers in touch", "تواصل المشترين"],
  "tools.market": ["Your price in the market", "سعرك في السوق"],
  "tools.noMarket": ["Not enough of this phone on Walashy yet to compare.", "لا يوجد ما يكفي من هذا الجوال في Walashy للمقارنة بعد."],
  "tools.rank": ["#{n} cheapest of {of} live listings of this phone", "الأرخص رقم {n} من {of} إعلان معروض لهذا الجوال"],
  "tools.changePrice": ["Change the price", "غيّر السعر"],
  "tools.dropHint": ["Lower it and everyone who saved it hears about the drop.", "خفّضه وسيصل إشعار لكل من حفظه."],
  "tools.priceSaved": ["Price updated", "تم تحديث السعر"],
  "tools.saved": ["Saved", "تم الحفظ"],
  "tools.deals": ["Deals on this listing ({n})", "الصفقات على هذا الإعلان ({n})"],
  "tools.noDeals": ["No one has been in touch yet.", "لم يتواصل أحد بعد."],
  "tip.price_high": ["Your price is above what this phone usually sells for. Under {p} would be in the market range.", "سعرك أعلى من المعتاد لهذا الجوال. أقل من {p} يجعله ضمن نطاق السوق."],
  "tip.more_photos": ["Listings with 4 or more photos get more messages. You have {n}.", "الإعلانات بأربع صور أو أكثر تحصل على رسائل أكثر. لديك {n}."],
  "tip.describe": ["Add a few lines: how long you've had it, why you're selling, any repairs.", "أضف بضعة أسطر: مدة استخدامه، وسبب البيع، وأي إصلاحات."],
  "tip.enable_whatsapp": ["Let buyers reach you on WhatsApp too. Most buyers here prefer it.", "اسمح للمشترين بالتواصل عبر واتساب أيضاً. معظم المشترين يفضّلونه."],
  "tip.enable_whatsapp.cta": ["Turn on WhatsApp", "فعّل واتساب"],
  "tip.bump": ["Few views this week. Move it to the top, it's free once a day.", "مشاهدات قليلة هذا الأسبوع. ارفعه للأعلى مجاناً مرة يومياً."],
  "tip.expiring": ["Expires in {n} days. Renew it to keep it up.", "ينتهي خلال {n} أيام. جدّده ليبقى معروضاً."],
  "tip.renew": ["It expired. Renew it for free to bring it back.", "انتهى الإعلان. جدّده مجاناً ليعود."],
  "tip.fix": ["Do it now", "أضفها الآن"],
  "wiz.details": ["Condition and price", "الحالة والسعر"],
  "wiz.photosPublish": ["Photos and publish", "الصور والنشر"],
  "details.more": ["Add accessories, description or quantity", "أضف المرفقات أو الوصف أو الكمية"],
  "photos.suggested": ["Optional, but they help it sell:", "اختيارية لكنها تساعد على البيع:"],
  "price.guideFor": ["Market price, {c}", "سعر السوق، {c}"],
  "price.sellFast": ["Sell fast: {p}", "بيع سريع: {p}"],
  "price.useTypical": ["Typical: {p}", "المعتاد: {p}"],
  "price.noGuide": ["We'll show the market price here once there's enough of this phone on Walashy.", "سنعرض سعر السوق هنا عندما يتوفر ما يكفي من هذا الجوال في Walashy."],
  "price.free": ["You keep the full price. Walashy takes nothing.", "السعر كامل لك. Walashy لا يأخذ شيئاً."],
  "price.negotiable": ["Open to offers", "قابل للتفاوض"],
  "price.deliveryHintDirect": ["You arrange it with the buyer", "تتفق عليه مع المشتري"],

  // Direct marketplace: account
  "profile.tab.contact": ["Contact", "التواصل"],
  "profile.step.contact": ["Let buyers WhatsApp you", "اسمح للمشترين بمراسلتك عبر واتساب"],
  "contactPrefs.title": ["How buyers can reach you", "كيف يتواصل معك المشترون"],
  "contactPrefs.why": ["Buyers always see a chat button. Add WhatsApp or calls if you like; your number is shown only to a signed-in buyer who taps it, and every time is recorded.", "يرى المشترون زر المحادثة دائماً. أضف واتساب أو الاتصال إن أردت؛ لا يظهر رقمك إلا لمشترٍ مسجّل يضغط عليه، ويُسجَّل ذلك في كل مرة."],
  "contactPrefs.chat": ["Walashy chat", "محادثة Walashy"],
  "contactPrefs.chatHint": ["Private, with price proposals and deal tracking", "خاصة، مع اقتراح الأسعار ومتابعة الصفقة"],
  "contactPrefs.always": ["Always on", "مفعّلة دائماً"],
  "contactPrefs.whatsappHint": ["Opens WhatsApp with a message about the listing", "يفتح واتساب برسالة عن الإعلان"],
  "contactPrefs.callsHint": ["Shows your number so buyers can call", "يُظهر رقمك ليتصل المشتري"],
  "contactPrefs.number": ["The number buyers get", "الرقم الذي يصل للمشترين"],
  "contactPrefs.unverified": ["Not verified", "غير موثّق"],
  "contactPrefs.noNumber": ["No number yet.", "لا يوجد رقم بعد."],
  "contactPrefs.typeNumber": ["Type the mobile number buyers should use:", "اكتب رقم الجوال الذي يتواصل عليه المشترون:"],
  "contactPrefs.verifyHint": ["Tip: add and verify a mobile in the Profile tab to show buyers a verified number.", "نصيحة: أضف رقم جوال ووثّقه من تبويب الملف ليرى المشترون رقماً موثّقاً."],
  "contactPrefs.private": ["Never shown on listings, in search, or to anyone who isn't signed in.", "لا يظهر أبداً في الإعلانات أو البحث أو لأي شخص غير مسجّل."],
  "contactPrefs.saved": ["Saved", "تم الحفظ"],

  // Direct marketplace: browse, seller
  "trust.free": ["Free: no fees, no commission", "مجاني: بلا رسوم ولا عمولة"],
  "trust.direct": ["Talk to sellers directly, chat or WhatsApp", "تواصل مع البائع مباشرة، محادثة أو واتساب"],
  "trust.tracked": ["Every deal tracked, with a bill of sale", "كل صفقة موثّقة، مع عقد بيع"],
  "browse.alertMe": ["Alert me", "نبّهني"],
  "browse.alertSaved": ["Alert on", "التنبيه مفعّل"],
  "browse.alertOn": ["We'll tell you when a match is listed", "سنخبرك عند عرض جوال مطابق"],
  "seller.asSeller": ["As seller", "كبائع"],
  "seller.asBuyer": ["As buyer", "كمشترٍ"],
  "seller.takesCalls": ["Takes calls", "يستقبل الاتصالات"],

  // Direct marketplace
  "welcome.p.pay.s4": ["Both confirm: bill of sale", "أكّدا: عقد البيع"],
} as const satisfies Record<string, readonly [string, string]>;

export type MessageKey = keyof typeof M;
